import { render, staticRenderFns } from "./UiParticipantStatus.vue?vue&type=template&id=1a957396"
import script from "./UiParticipantStatus.vue?vue&type=script&lang=js"
export * from "./UiParticipantStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports